import { Component, Input } from '@angular/core';
import { Ride } from '../../../../models/ride';
import { DatePipe } from '@angular/common';
import { CapitalizePipe } from '../../../../@pipes/capitalize-pipe';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';

@Component({
  selector: 'app-ride-details-contracts',
  imports: [DatePipe, CapitalizePipe, PaginatorModule],
  templateUrl: './ride-details-contracts.html',
  styleUrl: './ride-details-contracts.scss'
})
export class RideDetailsContracts {

  @Input() rideDetails!: Ride

  first = 0
  rows = 20

  get pagedContracts() {
    return this.rideDetails.tarsContracts?.slice(this.first, this.first + this.rows) ?? []
  }

  get totalRecords() {
    return this.rideDetails.tarsContracts?.length ?? 0
  }

  onPageChange(event: PaginatorState) {
    this.first = event.first ?? 0
    this.rows = event.rows ?? 10
  }
}
